import React from 'react'

import StyledEbestDividendInvestingGuide from '@/components/pages/ebest/ebest-dividend-investing-guide/styled'
import Image from '@/components/common/image'

const strings = {
  mainTitle: `미국 주식으로
매달 월급을 받을 수 있다고요?`,
  introductionFirst: `미국 주식의 매력으로는 전 세계 최대 시장, 원하는 유형의 모든 투자처가 있는 2,600여 개의 ETF, 그리고 배당이 있습니다.

국내에서는 보통 1년에 1번, 4월에 배당금을 지급하는 기업이 대부분인데 반하여 미국은 대부분의 기업이 분기 배당을 하고 있으며 월 배당 지급 종목도 상당수 있습니다.
많은 미국의 분기 배당 실시 기업은 1,4,7,10월 2,5,8,11월 이런 식으로 각기 다른 시기별로 배당금을 지급하고 있습니다.

각 시기별로 배당금을 지급하는 대표적인 종목은 뭐가 있을까요?
`,
  introductionSecond: `이처럼 서로 다른 배당금을 지급하는 종목을 조합해서 포트폴리오를 구성하면 매월 배당금을 받을 수 있습니다.
예를 들어 머크, 애플, 마이크로소프트를 매수하면 매월 배당금을 받을 수 있습니다.
`,
  topicTitleFirst: `다양한 배당투자 방법`,
  firstTopicDescription: `이렇게 어떤 종목, ETF를 담는지에 따라 다양한 배당투자가 가능합니다. 예를 들어 종목코드 : O (리얼티 인컴), 종목코드 : DGRW (WISDOMTREE TRUST US QUALITY DIV GRWTH FUND) 등 월배당 기업이나 ETF에 투자하는 월배당 투자. 종목코드 : PG (프록터 앤드 갬블), 종목코드 : SCHD (SCHWAB DIVIDEND EQUITY ETF)
처럼 배당을 꾸준히 늘려오는 배당 성장 투자. 종목코드 : MO (알트리아), 종목코드 : JEPI (JPMORGAN EQUITY PREMIUM INCOME ETF)와 같은 고배당 투자가 가능합니다.`,
  topicTitleSecond: `배당 투자 시 주의할 점은?`,
  secondTopicDescription: `배당금 수령은 장점이 될 수 있지만 당 장 눈앞의 배당금만 쫓을 경우 주식거래의 목표인 시세 차익을 놓칠 수 있습니다. 기업이 돈을 벌어들이면 신규 투자를 하여 또 다른 수익원을 창출하여야 하는데 배당금으로 많은 액수를 지불하면 신규 투자 기회를 놓치기 때문입니다.`,
  topicTitleThird: `이상적인 배당투자는?`,
  thirdTopicDescriptionFirst: `배당의 원천은 기업의 이익입니다. 따라서 장기간 기업이 성장하면서 배당금 지급 규모도 늘리는 기업을 발굴하는 것이 중요한데요.
예를 들어 많은 투자자들로부터 사랑받는 배당 성장 ETF 중 하나인
종목코드 : SCHD (SCHWAB DIVIDEND EQUITY ETF)
의 경우 2012년에 1,000만 원을 투자해서 10년간 보유를 했다면 주가, 배당금 규모 모두 각각 3배씩 올라서 평가금액은 약 3,000만 원, 96만 원에 달하는 배당금은 덤으로 가져가고 있을 것입니다.`,
  thirdTopicDescriptionSecond: `이처럼 나만의 성공적인 포트폴리오를 만들어 파이어족을 꿈꿔보세요!`,
  warningText: `※주의 : 위에서 언급한 종목들은 추천 종목이 아닙니다.`,
}

const EbestDividendInvestingGuide = () => {
  return (
    <StyledEbestDividendInvestingGuide>
      <pre className="mainTitle">{strings.mainTitle}</pre>
      <pre className="introduction first">{strings.introductionFirst}</pre>
      <div className="company-images">
        <Image
          src="/images/ebest/dividend-company-images.png"
          alt="dividend company images"
          layout="responsive"
          width={327}
          height={758}
        />
      </div>
      <pre className="introduction second">{strings.introductionSecond}</pre>
      <pre className="topic-title first">{strings.topicTitleFirst}</pre>
      <pre className="topic-description first">{strings.firstTopicDescription}</pre>
      <pre className="topic-title second">{strings.topicTitleSecond}</pre>
      <pre className="topic-description second">{strings.secondTopicDescription}</pre>
      <pre className="topic-title third">{strings.topicTitleThird}</pre>
      <pre className="topic-description third">{strings.thirdTopicDescriptionFirst}</pre>
      <div className="table-image">
        <Image
          src="/images/ebest/chart-image.png"
          alt="chart image"
          layout="responsive"
          width={327}
          height={161}
        />
      </div>
      <pre className="topic-description third">{strings.thirdTopicDescriptionSecond}</pre>
      <p className="warning">{strings.warningText}</p>
    </StyledEbestDividendInvestingGuide>
  )
}

export default EbestDividendInvestingGuide
